 <template>
  <div
    class="lv-rounded-lg lv-text-card-foreground lv-bg-white lv-p-3 lv-px-4 lv-pl-5"
    :style="cardStyle"
  >
    <div class="lv-flex lv-items-center lv-justify-between">
      <div class="lv-flex-1">
        <p class="lv-text-xs lv-font-medium lv-text-gray-500 lv-uppercase lv-tracking-wide" style="margin: 0;">
          {{ label }}
        </p>

        <p
          class="lv-text-2xl lv-font-bold lv-mt-0.5"
          :style="valueStyle"
          style="line-height: 1.2; margin-bottom: 0.125rem;"
        >
          {{ value }}
        </p>

        <p
          v-if="subtitle"
          class="lv-text-xs-10 lv-text-gray-400 lv-mt-0.5"
          style="line-height: 1.4; margin-bottom: 0; display: flex; align-items: center; gap: 0.25rem;"
        >
          <slot name="subtitle-icon"></slot>
          {{ subtitle }}
        </p>
      </div>

      <div
        class="lv-p-2 lv-rounded-full"
        :style="iconContainerStyle"
      >
        <slot name="icon"></slot>
      </div>
    </div>
    <div
      v-if="$slots.footer"
      class="summary-card-footer"
    >
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SummaryCard',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    borderColor: {
      type: String,
      required: true
    },
    iconBackgroundColor: {
      type: String,
      required: true
    },
    valueColor: {
      type: String,
      default: null
    }
  },
  computed: {
    cardStyle () {
      return {
        minHeight: this.$slots.footer ? '128px' : '100px',
        boxShadow: `
          inset 4px -0.25px 0 0 ${this.borderColor},
          0 4px 6px -4px rgba(0,0,0,0.08)
        `
      }
    },
    valueStyle () {
      return {
        color: this.valueColor || '#2b3544'
      }
    },
    iconContainerStyle () {
      return {
        backgroundColor: this.iconBackgroundColor
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.summary-card-footer {
  margin-top: 0.75rem;
  padding-top: 0.5rem;
  border-top: 1px solid #d1d5db;
  min-height: 2.5rem;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/SummaryCard.vue